import {
  GAME_ID,
  REDUX_ACTIONS,
  FEEDBACK_STATES,
  ROUND_STATES,
} from 'a/allAboard/data/constants';
import ALEX_STATES from 'a/components/GameHeader/AlexStates';

const initialState = {
  currentLevelIndex: 0, // The current level (0 indexed) that the user is playing
  currentQuestionIndex: 0, // The index of the question in the current question set (0 indexed).
  feedbackState: FEEDBACK_STATES.NONE, // Which feedback the user is receving. Options (None - not currently in a feedback state, CorrectFirst, correctSecond, incorrectFirst, incorrectSecond)
  roundState: ROUND_STATES.NO_ACTIVE_ROUND,
  isOnboarding: false,
  itemResponseOutcomesAllQ: [], // An array keeping track of if the user will recieve credit towards mastery for each question in the current round (true) or not (false)
  responseAttemptCountThisQ: 0, // Which try is the user on in terms of answering the current question - Used in determining feedback state
  alexState: ALEX_STATES.ACTIVE, // Whether Alex is speaking or not.
  alexInstruction: '',
  isSpeakerIconWiggling: false,
};

// This reducer keeps track of data that is specific to the round the user is playing. (Other than the maze / train etc.)
const roundPlayReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SELECT_LEVEL:
      return {
        ...state,
        currentLevelIndex: payload,
      };
    case REDUX_ACTIONS.INIT_ROUND_STATE:
      return {
        ...initialState,
        gameType: payload.gameType,
        currentLevelIndex: payload.levelIndex,
        roundState: ROUND_STATES.QUESTION,
      };

    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarding: false,
      };

    case REDUX_ACTIONS.INIT_ONBOARDING: {
      return {
        ...state,
        gameType: payload.gameType,
        isOnboarding: payload.isOnboarding,
        alexState: ALEX_STATES.ACTIVE,
      };
    }

    case REDUX_ACTIONS.END_FEEDBACK: {
      // We go to the next question if the user in all FEEDBACK_STATES except for Incorrect on the first try
      // and we do not go to the next question if it is the end of the round
      const shouldGoToNextQuestion = !payload.isEndOfRound && state.feedbackState !== FEEDBACK_STATES.INCORRECT_FIRST;

      return {
        ...state,
        // With an action of type END_FEEDBACK, we no longer want to be in a feedback state -> change it to none
        feedbackState: FEEDBACK_STATES.NONE,
        // After ROUND_STATE.FEEDBACK, we return to ROUND_STATE.QUESTION unless it is the end of the round
        roundState: payload.isEndOfRound ? ROUND_STATES.END_OF_ROUND_RESULTS : ROUND_STATES.QUESTION,
        // If we are going to start a new question, we increment the currentQuestionIndex, -- Otherwise we keep it the same
        currentQuestionIndex: shouldGoToNextQuestion ? state.currentQuestionIndex + 1 : state.currentQuestionIndex,
        // If you are going to the next question, we must reset the response attempt count to 0, since they haven't attempted this new question yet
        responseAttemptCountThisQ: shouldGoToNextQuestion ? 0 : state.responseAttemptCountThisQ + 1,
      };
    }

    case REDUX_ACTIONS.PROVIDE_FEEDBACK: {
      let feedbackType; // Feedback type is used to pick which FEEDBACK_STATE the user is in
      if (payload.isCorrect === true) { // The student has gotten the current question correct
        // Depending on if the user is on the first (responseAttemptCountThisQ = 0) or second (rACTQ = 1) try
        // The user is either going to be given Correct First ,or Correct second feedback
        feedbackType = state.responseAttemptCountThisQ === 0 ?
          FEEDBACK_STATES.CORRECT_FIRST : FEEDBACK_STATES.CORRECT_SECOND;
      } else if (payload.isCorrect === false) {
        // The student has gotten the current question wrong
        // Depending on if the user is on the first (rACTQ = 0) or second (rACTQ = 1) try
        // The user is either going to be given Incorrect First or Incorrect second feedback
        feedbackType = state.responseAttemptCountThisQ === 0 ?
          FEEDBACK_STATES.INCORRECT_FIRST : FEEDBACK_STATES.INCORRECT_SECOND;
      }

      return {
        ...state,
        feedbackState: feedbackType,
        roundState: ROUND_STATES.FEEDBACK,
        itemResponseOutcomesAllQ: state.responseAttemptCountThisQ === 0 ?
          [...state.itemResponseOutcomesAllQ, payload.isCorrect] : state.itemResponseOutcomesAllQ,
      };
    }

    case REDUX_ACTIONS.ALEX_SPEAKING:
      return {
        ...state,
        alexState: 2, // ALEX_STATES.ACTIVE,
      };

    case REDUX_ACTIONS.ALEX_SILENT:
      return {
        ...state,
        alexState: ALEX_STATES.INACTIVE,
      };
    case REDUX_ACTIONS.ALEX_PAUSE:
      return {
        ...state,
        alexState: ALEX_STATES.ACTIVE,
      };
    case REDUX_ACTIONS.SAVE_ALEX_INSTRUCTIONS:
      return {
        ...state,
        alexInstruction: payload.instruction,
      };
    case REDUX_ACTIONS.SET_IS_SPEAKER_ICON_WIGGLING:
      return {
        ...state,
        isSpeakerIconWiggling: payload.isSpeakerIconWiggling,
      };
    case REDUX_ACTIONS.QUICK_ROUND:
      return {
        ...state,
        itemResponseOutcomesAllQ: Array(payload.questionCount).fill(payload.pass),
        roundState: ROUND_STATES.END_OF_ROUND_RESULTS,
      };
    default:
      return state;
  }
};

export default roundPlayReducer;
